import type { MaybeRef } from 'vue'
import { toValue } from 'vue'
import { FetchMethod } from '../../models/api/fetch-method'
import { useApiClient } from './useApiClient'

export default function usePost<TOutput, TBody = unknown>(
  endpoint: MaybeRef<string>,
  omitOrganization: boolean = false,
  headers?: MaybeRef<Record<string, string> | undefined>,
) {
  const { data, status, error, execute } = useApiClient<TOutput, TBody>()

  const mutate = async (body?: TBody) => {
    await execute({
      method: FetchMethod.POST,
      endpoint: toValue(endpoint),
      omitOrganization,
      body,
      headers: toValue(headers),
    })
  }

  return { data, status, error, mutate }
}
